import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateIntegrationTypeCard = document.createElement('template');

templateIntegrationTypeCard.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
       <gz-card cardWidth="400">
          <div class="card-integration-type ellipsis"></div>
          <div class="card-description ellipsis"></div>
           <div class="card-license-active hidden">
                <gz-title fontSize="12" fontWeight="500" id="license-title"></gz-title>
                <div class="card-license-active-wrapper">
                  <div class="labeled-content-container">
                      <gz-labeled-content id="license-status-label" hasColon></gz-labeled-content>
                      <gz-labeled-content id="license-expire-label" hasColon></gz-labeled-content>
                  </div>
                  <gz-button id='integrate-button'
                    class="primary btn-integrate"
                    type="outline"
                    onmouseleave="this.setAttribute('type','outline')"
                    onmouseenter="this.setAttribute('type','full')"
                  >
                  </gz-button>
                  <gz-button id='requirements-button'
                    class="primary btn-integrate"
                    type="outline"
                    onmouseleave="this.setAttribute('type','outline')"
                    onmouseenter="this.setAttribute('type','full')"
                  >
                  </gz-button>
                </div>
           </div>
           <div class="card-license-not-active hidden">
                <div class="card-license-not-active-wrraper">
                 <span class="cell-label has-bullet" id="card-license-status"></span>
                    <gz-button id='add-license-button'
                     class="primary btn-integrate hidden"
                     type="outline"
                     onmouseleave="this.setAttribute('type','outline')"
                     onmouseenter="this.setAttribute('type','full')"
                   >
                   </gz-button>
                   <gz-info-box severity="warning" class="hidden"></gz-info-box>
                </div>
           </div>
       </gz-card>
  </div>
`;
